const parseCarousellData = (data) => {
  return Object.entries(data).map(([key, value]) => {
    if (value && (value.titulo || value.contenido || value.imagen?.node?.mediaItemUrl)) {
      return { 
        title: value.titulo || null, 
        content: value.contenido || null, 
        mediaItemUrl: value.imagen?.node?.mediaItemUrl || null, 
        imageName: value.imagen?.node?.title || null,
      }; 
    }
    return null;
  }).filter(item => item !== null);
}
export default parseCarousellData;